module.exports = __webpack_public_path__ + "static/media/logo_icon.96ce878e.png";